import React from 'react'
import { change, Field } from 'redux-form'
import { fieldStyle } from '../../form/style'
import { Tooltip, IconButton } from '@mui/material'
import { CATALOGUE_FORM } from '../../../services/forms'
import { Close } from '@mui/icons-material'
import { useDispatch, useSelector } from 'react-redux'
import { AutoComplete } from './AutoComplete'
import { COLOR_LIGHT_TEXT } from '../../../config/colors'

export const AddPersonsField = ({ member, index, fields }) => {
  const persons = useSelector((state) => state.provenancePersons.items)
  const cataloguePersons = Object.values(persons).map((i) => ({
    id: i.id,
    name: `${i.firstname} ${i.lastname} (b. ${i.birth_year})`,
  }))
  const dispatch = useDispatch()
  const changeFieldValue = (field, value) => {
    dispatch(change(CATALOGUE_FORM, field, value))
  }

  return (
    (<div key={index} className="flex-box select-reference artwork-row repeater-field">
      <div className="field">
        <Field
          name={`${member}.id`}
          items={cataloguePersons}
          changeFieldValue={changeFieldValue}
          {...fieldStyle}
          component={AutoComplete}
        />
      </div>
      <Tooltip title="Remove">
        <IconButton
          className="repeater-remove"
          onClick={() => fields.remove(index)}
          size="large">
          <Close style={{ color: COLOR_LIGHT_TEXT}} />
        </IconButton>
      </Tooltip>
    </div>)
  );
}
